import React, { createContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const replaceDocument = (url: string): void => window.location.replace(url);

export const NewAnalyticsBasePathContext = createContext<string | undefined>(
  undefined,
);

export function newAnalyticsDestination(
  basePath: string | undefined,
  path?: string,
  search = '',
  hash = '',
): string | undefined {
  if (!basePath || typeof path !== 'string') return;
  const page = path
    .match(/^\/(?:activity\/)?(overview|readers(?:\/profiles)?)(?:\/|$)/i)?.[1]
    .toLowerCase();
  if (page) return `${basePath}/activity/${page}${search}${hash}`;
}

export const AnalyticsExperienceBoundary: React.FC<{
  newAnalytics: boolean;
  basePath: string;
  navigate?: (url: string) => void;
  children?: React.ReactNode;
}> = ({ newAnalytics, basePath, navigate = replaceDocument, children }) => {
  const location = useLocation();
  const legacyHash = location.hash.startsWith('#/activity');
  const path = legacyHash ? location.hash.slice(1) : location.pathname;
  const newBasePath = newAnalytics ? basePath : undefined;
  const destination = newAnalyticsDestination(
    newBasePath,
    path,
    location.search,
    legacyHash ? '' : location.hash,
  );
  const redirected = useRef<string>();

  useEffect(() => {
    if (!destination) {
      redirected.current = undefined;
      return;
    }
    if (redirected.current === destination) return;
    redirected.current = destination;
    navigate(destination);
  }, [destination, navigate]);

  return destination ? null : (
    <NewAnalyticsBasePathContext.Provider value={newBasePath}>
      {children}
    </NewAnalyticsBasePathContext.Provider>
  );
};
